export default __webpack_public_path__ + "static/hand-painted-leaf-border-cut-d097d5ff88662f20e4582580196dba05.png";